import React from "react";

const DefectsPage = (props) => {
	return <div>{props.children}</div>;
};

export default DefectsPage;
